<template>
  <div class="page border-box" v-wechat-title="$route.meta.title='评价'">
    <div class="con border-box">
      <p class="tit cor3">您对本次讲解服务满意吗？</p>
      <div class="goods border-box box">
        <div class="l">
          <img class="img" :src="order.guidelogo" alt="">
        </div>
        <div class="r flex">
          <p>讲解员：{{order.guidename}}</p>
          <p>订单总价：￥{{order.totalmoeny}}</p>
          <p v-if="order && order.time">服务时间：{{order.time.slice(5)}} {{order.stime}}-{{order.etime}}</p>
        </div>
      </div>
      <div class="score score1">
        <span class="fl l">服务满意度</span>
        <div class="fl m">
          <template v-for="(item,index) in [1,2,3,4,5]">
            <img @click="starSelect(index,0)" v-if="scoreArr[0].score>=item" src="../../assets/icon-star-curr1.png"/>
            <img @click="starSelect(index,0)" v-if="scoreArr[0].score<item" src="../../assets/icon-star1.png" />
          </template>
        </div>
        <span class="fl r">{{scoreArr[0].name}}</span>
      </div>
      <div class="score score3">
        <span class="fl l">讲解内容</span>
        <div class="fl m">
          <template v-for="(item,index) in [1,2,3,4,5]">
            <img @click="starSelect(index,2)" v-if="scoreArr[2].score>=item" src="../../assets/icon-star-curr1.png"/>
            <img @click="starSelect(index,2)" v-if="scoreArr[2].score<item" src="../../assets/icon-star1.png" />
          </template>
        </div>
        <span class="fl r">{{scoreArr[2].name}}</span>
      </div>
      <div class="score score2">
        <span class="fl l">服务态度</span>
        <div class="fl m">
          <template v-for="(item,index) in [1,2,3,4,5]">
            <img @click="starSelect(index,1)" v-if="scoreArr[1].score>=item" src="../../assets/icon-star-curr1.png"/>
            <img @click="starSelect(index,1)" v-if="scoreArr[1].score<item"  src="../../assets/icon-star1.png" />
          </template>
        </div>
        <span class="fl r">{{scoreArr[1].name}}</span>
      </div>
      <div class="label clearfix" v-if="order.labels && order.labels.length>0">
        <span v-for="(item,index) in order.labels" :key="index"  :class="item.code==true?'curr':''" @click="labelFunc(index)">{{item.name}}</span>
      </div>
      <textarea class="border-box" name="" id="" cols="30" rows="10" maxlength="200" placeholder="写下您的体验感受告诉讲解员，激励我们做得更好" v-model="tipValue"></textarea>
      <div class="upload-box clearfix">
        <div class="upload-img" v-for="(url,index) in imgSrcs" v-show="imgSrcs.length" @click="preViewImgs(index)">
          <img class="img" :src="url" v-if="typeof url === 'string'" />
          <img class="img" :src="url.file.src" v-else />
          <img class="icon-close" src="../../assets/icon-close2.png" alt="" @click.stop="delImg(index)">
        </div>
        <div class="upload-img" v-if="imgSrcs.length<9">
          <input @change="fileChange($event)" type="file" id="upload_file" multiple style="display: none"/>
          <img class="img" src="../../assets/icon-upload.png" alt="" @click="chooseType">
        </div>
      </div>

      <div class="btn linear" @click="submitFun">提交</div>
    </div>

    <!--评论成功弹窗-->
    <div class="alert-success border-box tc" v-if="successShow==1">
      <img class="icon-sus" src="../../assets/icon-sus.png" alt="">
      <div class="t1 bold">评价成功</div>
      <div class="t2">感谢你！对本次服务的支持！</div>
      <div class="alert-btn btn1" @click="toHome">回到首页</div>
      <!--<div class="alert-btn btn2" @click="successShow=0,rewardShow = 1;">关闭</div>-->
      <!--<div class="alert-btn btn2" @click="successShow=0,rewardShow = 1;">关闭</div>-->
    </div>

    <!--打赏弹窗-->
    <div class="alert-reward tc" v-if="rewardShow==1">
      <div class="mask" @click="rewardShow=0"></div>
      <div class="alert-con">
        <p class="alert-title">讲的非常好！</p>
        <p class="alert-sub" v-if="dsTotal>0">共有{{dsTotal}}人打赏，支持鼓励导游！</p>
        <p class="alert-sub" v-else>打赏一下，支持鼓励导游！</p>
        <div class="img-box clearfix">
          <img class="img" v-lazy="item.headimg" alt="" v-for="(item,index) in dslist" :key="index">
          <img class="icon-dian" src="../../assets/icon-dian.png" alt="" v-if="dslist.length>=15">
        </div>
        <div class="reward-money clearfix">
          <span @click="clickFixedNum(10)" :data-price="10" class="hide" v-bind:class="{ curr:10==currentPrice}">10元</span>
          <span @click="clickFixedNum(8)" :data-price="8" class="hide" v-bind:class="{ curr:8==currentPrice}">8元</span>
          <span @click="clickFixedNum(5)" :data-price="5" class="hide" v-bind:class="{ curr:5==currentPrice}">5元</span>
          <span @click="clickFixedNum(2)" :data-price="2" class="hide" v-bind:class="{ curr:2==currentPrice}">2元</span>
        </div>
        <div class="reward-money-input border-box clearfix">
          <span class="fl">打赏金额：</span>
          <input class="fl" placeholder='土豪请随意' maxlength="5" type="number" @keydown="handleInput2" number v-model.number="inputPrice" v-on:input="inputNum(inputPrice)"/>
        </div>
        <div class="btn-box">
          <div class="fl btn" @click="rewardShow=0">我不打赏</div>
          <div class="fr btn linear" @click="dsOrder">打赏{{currentPrice}}元</div>
        </div>
      </div>
    </div>

    <img class="to-home" src="../../assets/to-home.png" @click="toHome" alt="">

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>
<script>
  import P400 from '../../components/P400'
  import {getUserPreComment, getUserComment,getUserDSList} from "@/service/getData";
  import {wxGetPosition,wxShareme, uploadFile,creatDSOrder} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import Exif from 'exif-js'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        P400: 0, //系统维护中
        scenicId: this.$route.query.scenicId || '', //景区id
        scenicKey: this.$route.query.scenicKey || '', //来源标记
        ordernum: this.$route.query.ordernum || '',
        order: '', //预评价信息

        dslist: '', //此订单的打赏列表
        dsTotal: 0, //打赏总数

        scoreArr:[
          {score:5,name:'超赞'},
          {score:5,name:'超赞'},
          {score:5,name:'超赞'}
        ],//总体评分评价
        tipValue:'',//建议

        labels:'',//提交评论时的评论标签id字符串
        labelStr: '', //记录上次标签字符
        successShow: 0,//评论成功弹窗 0：不显示 1：显示
        currentPrice:5,//选项卡
        inputPrice:'',//input框值,
        rewardShow: 0,//打赏弹窗 0：隐藏 1：显示

        imglength: 0, //有图片的原始图片长度
        imgSrcs: [], //存放图片地址
        limit:9, //限制图片上传的数量
        isSuccess: false, //评论是否提交
      }
    },
    computed: {},

    created(){
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.getUserPreCommentFun()
    },
    methods: {
      //获取预评价订单信息
      async getUserPreCommentFun(){
        let res = await getUserPreComment({
          openid: this.userInfo.openid,
          ordernum: this.ordernum,
          time: (new Date().getTime())
        });
        if (res.errcode == "00000") {
          this.order = res.data

          this.getUserDSListFun();
        }else {
          this.$toast(res.errmsg);
        }
      },

      //获取打赏头像列表
      async getUserDSListFun(){
        let res = await getUserDSList({
          guideId: this.order.guideId,
          pageNum: 1,
          pageSize: 15,
          time: (new Date().getTime())
        });
        this.$loading.hide();
        if (res.errcode == "00000") {
          this.dslist = res.data;
          this.dsTotal = res.total;
        }else {
          this.$toast(res.errmsg);
        }
      },

      //打赏订单
      dsOrder: function (){
        if(this.currentPrice<1){
          this.$toast('打赏金额不小于1元');
        } else if(this.currentPrice>2000){
          this.$toast('打赏金额不大于2000元');
        } else {
          var obj = {
            openid: this.userInfo.openid,
            guideId: this.order.id,
            money: this.currentPrice,
            ordernum: this.ordernum
          };
          var self = this;
          creatDSOrder(self,obj,function(data){
            if(data){
              self.clickFixedNum(2);
              self.rewardShow=0;
            }
          });
        }

      },

      //上传图片
      chooseType: function(){
        document.getElementById('upload_file').click();
      },
      fileChange: function(el){
        if (!el.target.files[0].size) return;
        this.fileList(el.target);
        el.target.value = ''
      },
      fileList: function(fileList){
        let files = fileList.files;

        for (let i = 0; i < files.length; i++) {
          //判断是否为文件夹
          if (files[i].type != '') {
            this.fileAdd(files[i]);
          } else {
            //文件夹处理
            this.folders(fileList.items[i]);
          }
        }
      },
      //文件夹处理
      folders: function(files){
        let self = this;
        //判断是否为原生file
        if (files.kind) {
          files = files.webkitGetAsEntry();
        }
        files.createReader().readEntries(function (file) {
          for (let i = 0; i < file.length; i++) {
            if (file[i].isFile) {
              self.foldersAdd(file[i]);
            } else {
              self.folders(file[i]);
            }
          }
        });
      },
      foldersAdd: function(entry){
        let self = this;
        entry.file(function (file) {
          self.fileAdd(file)
        })
      },
      fileAdd: function(file){
        let self = this;
        let Orientation;
        Exif.getData(file, function(){
          Orientation = Exif.getTag(this, 'Orientation');
        });

        if (this.limit !== undefined) this.limit--;
        if (this.limit !== undefined && this.limit < 0) return;
        //判断是否为图片文件
        if (file.type.indexOf('image') == -1) {
          this.$toast("请选择图片文件",{ location: ''})
        } else {
          let reader = new FileReader();
          let image = new Image();
          reader.readAsDataURL(file);
          reader.onload = function () {
            file.src = this.result;
            image.src = file.src;
            image.onload = function () {
              file.width = image.width;
              file.height = image.height;
              self.imgSrcs.push({file});
            };
          }
        }
      },
      delImg: function(index){
        this.imgSrcs.splice(index, 1);
        if (this.limit !== undefined) this.limit = 9 - this.imgSrcs.length;
      },

      //评分
      starSelect: function(index,type) {
        if(type==0){
          console.log(type)
          if(index<=4){
            if (index == 0) {
              this.$set(this.scoreArr[0],'name','糟糕');
              this.$set(this.scoreArr[0],'score', (index + 1) * 1);

              this.$set(this.scoreArr[1],'name','糟糕');
              this.$set(this.scoreArr[1],'score', (index + 1) * 1);

              this.$set(this.scoreArr[2],'name','糟糕');
              this.$set(this.scoreArr[2],'score', (index + 1) * 1);

            } else if (index == 1) {
              this.$set(this.scoreArr[0],'name','不好');
              this.$set(this.scoreArr[0],'score', (index + 1) * 1);

              this.$set(this.scoreArr[1],'name','不好');
              this.$set(this.scoreArr[1],'score', (index + 1) * 1);

              this.$set(this.scoreArr[2],'name','不好');
              this.$set(this.scoreArr[2],'score', (index + 1) * 1);

            } else if (index == 2) {
              this.$set(this.scoreArr[0],'name', '一般');
              this.$set(this.scoreArr[0],'score', (index + 1) * 1);

              this.$set(this.scoreArr[1],'name', '一般');
              this.$set(this.scoreArr[1],'score', (index + 1) * 1);

              this.$set(this.scoreArr[2],'name', '一般');
              this.$set(this.scoreArr[2],'score', (index + 1) * 1);

            } else if (index == 3) {
              this.$set(this.scoreArr[0],'name', '厉害');
              this.$set(this.scoreArr[0],'score', (index + 1) * 1);

              this.$set(this.scoreArr[1],'name', '厉害');
              this.$set(this.scoreArr[1],'score', (index + 1) * 1);

              this.$set(this.scoreArr[2],'name', '厉害');
              this.$set(this.scoreArr[2],'score', (index + 1) * 1);

            } else if (index == 4) {
              this.$set(this.scoreArr[0],'name', '超赞');
              this.$set(this.scoreArr[0],'score', (index + 1) * 1);

              this.$set(this.scoreArr[1],'name', '超赞');
              this.$set(this.scoreArr[1],'score', (index + 1) * 1);

              this.$set(this.scoreArr[2],'name', '超赞');
              this.$set(this.scoreArr[2],'score', (index + 1) * 1);

            }
          }
        }else{
          if(index<=4){
            if (index == 0) {
              this.$set(this.scoreArr[type],'name','糟糕');
            } else if (index == 1) {
              this.$set(this.scoreArr[type],'name','不好');
            } else if (index == 2) {
              this.$set(this.scoreArr[type],'name', '一般');
            } else if (index == 3) {
              this.$set(this.scoreArr[type],'name', '厉害');
            } else if (index == 4) {
              this.$set(this.scoreArr[type],'name', '超赞');
            }
          }
          this.$set(this.scoreArr[type],'score', (index + 1) * 1);
        }
      },
      //选择评论标签
      labelFunc: function(ind){

        if(this.order.labels[ind].code==true){
          this.order.labels[ind].code = false;
        }else{
          this.order.labels[ind].code = true;
        }

        var labelIds = [], arr = [];
        for(var i = 0;i<this.order.labels.length;i++){
          if(this.order.labels[i].code==true) {
            labelIds.push(this.order.labels[i].id);
            arr.push(this.order.labels[i].name)
          }
        }

        this.labels = labelIds.toString();

        if(this.labelStr){
          this.tipValue = this.tipValue.replace(this.labelStr,'')
        }
        this.labelStr = '#' + arr.join(',') + '#';
        this.tipValue = this.labelStr + this.tipValue
      },

      //点击提交按钮
      submitFun:function(){
        if(this.isSuccess){
          return;
        }
        this.isSuccess = true;

        /*
        if(!this.tipValue){
          this.$toast('请写下您的体验感受~');
          this.isSuccess = false;
          return;
        }
        */

        let self = this;
        if(this.imgSrcs.length > 0){
          this.$loading.show('图片上传...');
          var imgarr = [];
          for(var i=0; i<this.imgSrcs.length; i++){

            var formData = new FormData();
            formData.append('Filedata', self.imgSrcs[i].file);

            uploadFile(formData,function(res){
              if(res.data.errcode == "00000"){
                imgarr.push(res.data.data.url);
                if(imgarr.length == self.imgSrcs.length){
                  var imgs = imgarr.join(',');
                  self.getUserCommentFun(imgs);
                }
              }else {
                self.$loading.hide();
                self.$toast('图片上传出错')
                self.isSuccess = false;
              }
            });
          }
        }else {
          self.getUserCommentFun('');
        }
      },

      //调用提交评论接口
      async getUserCommentFun(imgs){
        this.$loading.show('提交评论中');
        let res = await getUserComment({
          openid: this.userInfo.openid,
          ordernum: this.ordernum,
          content: this.tipValue || '',
          score: this.scoreArr[0].score || 0, //整体评分
          tscore: this.scoreArr[1].score || 0, //态度评分
          gscore: this.scoreArr[2].score || 0, //规范评分
          img: imgs || '',
          labels: this.labels
        });
        if (res.errcode == "00000") {
          this.$loading.hide();
          this.tipValue = [];
          this.successShow = 1;
        } else {
          this.$toast(res.errmsg);
        }
        this.isSuccess = false;
      },

      //提交打赏订单
      dsOrder: function(){
        if(this.currentPrice<1){
          this.$toast('打赏金额不小于1元');
        } else if(this.currentPrice>2000){
          this.$toast('打赏金额不大于2000元');
        } else {
          var obj = {
            openid: this.userInfo.openid,
            guideId: this.order.id,
            money: this.currentPrice,
            ordernum: this.ordernum
          };
          var self = this;
          creatDSOrder(self,obj,function(data){
            if(data){
              self.clickFixedNum(2);
              self.rewardShow=0;
            }
          });
        }
      },

      // 通过正则过滤小数点后两位
      handleInput2(e) {
        e.target.value = e.target.value.replace(/[^\d]/g,'');
      },
      //选择打赏金额
      clickFixedNum(item){
        this.currentPrice=item;
        this.inputPrice = ''
      },
      //输入打赏金额
      inputNum(inputPrice){
        this.currentPrice = inputPrice;
        if(inputPrice==''||inputPrice==undefined){
          this.currentPrice = 10
        }
      },
      //返回至首页
      toHome(){
        this.$router.replace({path: `/?scenicId=`+this.scenicId+'&scenicKey='+this.scenicKey });
      },
    },
    watch: {},
    components: {P400}
  }

</script>

<style scoped>
  @import "../../style/alert.css";
  .page{min-height:100vh;padding: .3rem;background-color:#f2f2f2}
  .con{ width:100%;min-height: calc(100vh - .6rem);padding:0 .3rem;background: #fff;border-radius: .13rem;}
  .con .tit{height:1rem;font: bold .32rem/1.12rem "Microsoft YaHei";border-bottom:1px solid #e3e3e3;}
  .con .goods{padding: .3rem 0 .54rem;}
  .con .goods .l{width: 1.48rem;height: 1.48rem;margin-right:.2rem;border-radius: .07rem;overflow: hidden;}
  .con .goods .l img{width: 100%;height: 100%;object-fit: cover;object-position: top;}
  .con .goods .r p{font: .28rem/.5rem "Microsoft YaHei";color: #666;}
  .score{width: 100%;height:.3rem;color: #666;margin-top: .3rem;}
  .score.score1{height: .36rem;}
  .score .l{width: 26%;height:100%;font: bold .24rem/.3rem "Microsoft YaHei";color: #666;}
  .score.score1 .l{font: bold .28rem/.36rem "Microsoft YaHei";color: #333;}
  .score .m{width:55%;height: 100%;}
  .score .m img{float: left;width: auto;height: 100%;margin-right: .3rem;vertical-align: top;}
  .score .r{font: .24rem/.3rem "Microsoft YaHei";color: #666;}
  .score.score1 .r{font: .28rem/.36rem "Microsoft YaHei";color: #333;}
  .label{margin-top: .26rem;}
  .label span{float:left;display: inline-block;margin-top: .14rem;padding: 0 .24rem;font: .22rem/.44rem "Microsoft YaHei";color: #666;margin-right: .16rem;border-radius: .3rem;background: #f7f8fa;}
  .label span:nth-of-type(4n){margin-right: 0;}
  .label span.curr{color: #e58619;background: #fcf0e3;}
  textarea{width:100%;height: 2.1rem;padding:.16rem .22rem;margin-top:.26rem;border:1px solid #e0e0e0;border-radius: .1rem;background: #f7f8fa;font: .24rem/.36rem "Microsoft YaHei";color: #999;resize: none;}
  .upload-img{position:relative;float:left;width: 1.28rem;height: 1.28rem;margin-top:.15rem;margin-left:.15rem;border:1px solid #e3e3e3;border-radius: .13rem;}
  .upload-img:first-child{margin-left: 0;}
  .upload-img img{width: 100%;height: 100%;object-fit: cover;border-radius: .13rem;overflow: hidden;}
  .upload-img .icon-close{position: absolute;top:-.08rem;right:-.08rem;z-index:1;width: .28rem;height: .28rem;}
  .btn{width: 100%;height: .8rem;margin-top: .3rem;margin-left:0;font: .36rem/.8rem "Microsoft YaHei";}
  /*评论成功弹窗*/
  .alert-success{position: fixed;top:0;left: 0;z-index:9;width: 100vw;height: 100vh;padding:0 .3rem;background: #fff;}
  .alert-success .icon-sus{display: block;width: 2rem;height:auto;margin: .52rem auto 0;}
  .alert-success .t1{font: .4rem "Microsoft YaHei";color: #000;margin-top: .58rem;}
  .alert-success .t2{font: .28rem "Microsoft YaHei";color: #888;margin-top: .46rem;}
  .alert-success .alert-btn{width: 100%;height: .86rem;font: .36rem/.86rem "Microsoft YaHei";border-radius: .4rem;letter-spacing: .03rem;}
  .alert-success .alert-btn.btn1{margin-top: .68rem;background: #09bb07;color:#fff;border:1px solid #029400;}
  .alert-success .alert-btn.btn2{margin-top: .3rem;background: #fbfafc;color: #000;border:1px solid #d6d5d6;}
</style>



// WEBPACK FOOTER //
// src/page/home/comment.vue